<template>
    <div>
        <div class="d-flex gap-4">
            <a
                v-if="impressumLink"
                :href="impressumLink"
                target="_blank"
                class="font-weight-bold text-body text-sm">Impressum</a>
            <a
                v-if="privacyLink"
                :href="privacyLink"
                target="_blank"
                class="font-weight-bold text-body text-sm">Datenschutz</a>
        </div>
    </div>
</template>

<script>
import mainSiteMixin from "@/mixins/mainSiteMixin";

export default {
    name: "Impressum",
    mixins: [mainSiteMixin],
    computed: {
        impressumLink() {
            return this.sanitizeLink(this.siteData?.organizer?.impressumLink ?? null)
        },
        privacyLink() {
            return this.sanitizeLink(this.siteData?.organizer?.privacyLink ?? null)
        }
    },
    methods: {
        sanitizeLink(link) {
            if (!link) return null
            if (link.startsWith('http')) return link
            return '//' + link
        }
    }
}
</script>

<style scoped>
p {
    font-size: smaller;
    margin-left: .5rem;
}
</style>
